import { trackEvent } from "utils/analytics";

export const EventUploadLimitError = (location: string) => {
  trackEvent(`${location}_upload_limit_error`);
};

export const EventLike = (location: string) => {
  trackEvent(`${location}_like`);
};

export const EventUnlike = (location: string) => {
  trackEvent(`${location}_unlike`);
};

export const EventSaveCollection = (location: string) => {
  trackEvent(`${location}_save_to_collection`);
};
